import React from 'react';
import ReactApexChart from 'react-apexcharts';

const TicketOverview = ({ states }) => {
    const thirdChart = states?.third_chart_data || {};

    // Extract series and labels
    const series = Object.values(thirdChart).map(item => item?.counts || 0);
    const labels = Object.keys(thirdChart);

    // Define color map (up to 4)
    const colorMap = {
        Pending: "bg-warning-main",
        pending: "bg-warning-main",
        Accepted: "bg-success-main",
        accepted: "bg-success-main",
        Scheduled: "bg-primary-600",
        scheduled: "bg-primary-600",
        Completed: "bg-info-main",
        completed: "bg-info-main",
    };

    // Chart options
    const options = {
        colors: labels.map(label => {
            switch (label) {
                case "Pending": return "#FF9F29";
                case "pending": return "#FF9F29";
                case "Accepted": return "#45B369";
                case "accepted": return "#45B369";
                case "Scheduled": return "#39B6E2";
                case "scheduled": return "#39B6E2";
                case "Completed": return "#487FFF";
                case "completed": return "#487FFF";
                default: return "#B0B0B0";
            }
        }),
        labels: labels,
        legend: { show: false },
        chart: {
            type: "donut",
            height: 300,
            sparkline: { enabled: true },
        },
        stroke: { width: 0 },
        dataLabels: { enabled: false },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: { width: 200 },
                    legend: { position: "bottom" },
                },
            },
        ],
        plotOptions: {
            pie: {
                startAngle: -90,
                endAngle: 90,
                offsetY: 10,
                customScale: 0.8,
                donut: {
                    size: "70%",
                    labels: {
                        show: true,
                        total: {
                            showAlways: true,
                            show: true,
                            label: "Tickets Overview",
                        },
                    },
                },
            },
        },
    };

    return (
        <div className="col-xxl-6" style={{ height: "100%" }}>
            <div className="col-xxl-12 col-sm-6 h-100">
                <div className="card h-100 radius-8 border-0 overflow-hidden">
                    <div className="card-body p-16 h-100">
                        <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                            <h6 className="mb-2 fw-bold text-lg">Tickets Overview</h6>
                        </div>
                        <div className="d-flex flex-wrap align-items-center mt-3">
                            <ul className="flex-shrink-0 me-4">
                                {Object.entries(thirdChart).map(([label, data]) => (
                                    <li key={label} className="d-flex align-items-center gap-2 mb-2">
                                        <span className={`w-12-px h-12-px rounded-circle ${colorMap[label] || 'bg-secondary-light'}`} />
                                        <span className="text-secondary-light text-sm fw-medium">
                                            {label}: {data.counts}
                                            {/* ({data.percent}%) */}
                                        </span>
                                    </li>
                                ))}
                            </ul>

                            <div>
                                <ReactApexChart
                                    options={options}
                                    series={series}
                                    type="donut"
                                    height={250}
                                    id="donutChart"
                                    className="flex-grow-1 apexcharts-tooltip-z-none title-style circle-none"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TicketOverview;
